<template>
  <div class="mt-3">
    <div class="col-xs-12 col-md-12 text-center">
      <button class="btn btn-sm capitalize" @click="print">{{buttontext}}</button>
    </div>
    <div :id="name" class="text-sm printablehandout">
        <slot></slot>
    </div>
  </div>
</template>

<script>
import VueHtmlToPaper from 'vue-html-to-paper';
const options = {
  name: '_blank',
  specs: [
    'fullscreen=no',
    'titlebar=no',
    'scrollbars=no'
  ],
  styles: [
    '/css/app.css'
  ]
}
Vue.use(VueHtmlToPaper, options);
    export default {
      props: {
        name: '',
        buttontext: {
            default: 'PRINT THIS HANDOUT' 
        },
      },
      data() {
        return {
          output: null
        }
      },
        methods: {
          print() {
            // Pass the element id here
            this.$htmlToPaper(this.name);
          }
        },
    };
</script>